import styled from '@emotion/styled/macro';

import CreditCardTypeNumber from '../../../../styledComponents/CreditCard/CreditCardTypeNumber/CreditCardTypeNumber';

export const StyledCreditCardTypeNumber = styled(CreditCardTypeNumber)`
  margin-top: 0.875rem;
`;
